$(document).ready(function () {

  function getSingleLineHeight($el) {
    if (!$el || !$el.length) return 0;
    var $clone = $el.clone().css({
      position: 'absolute', visibility: 'hidden', height: 'auto',
      maxHeight: 'none', width: $el.width() + 'px', top: '-9999px',
      whiteSpace: 'normal', display: 'block',
      paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0,
      borderTop: 0, borderBottom: 0
    }).html('A');
    $el.after($clone);
    var node = $clone[0];
    var h = node ? node.getBoundingClientRect().height : 0;
    $clone.remove();
    return h;
  }

  function truncate($desc) {
    var $firstP = $desc.find('p').first();
    if (!$firstP.length) return;
    var hasMore = $desc.find('.more-content').length > 0;
    $firstP.css({ whiteSpace: 'normal', display: 'block' });
    $firstP.html($firstP.attr('data-original'));

    var paddingTop = parseFloat($firstP.css('padding-top')) || 0;
    var paddingBottom = parseFloat($firstP.css('padding-bottom')) || 0;
    var maxH = getSingleLineHeight($firstP) * 2 + paddingTop + paddingBottom + 2;

    if ($firstP[0].scrollHeight <= maxH) {
      if (hasMore && !$firstP.find('.read-more-btn').length) {
        $firstP.append(' <span class="read-more-btn">Read more</span>');
      }
      return;
    }

    var words = $firstP.text().trim().split(/\s+/);
    var btn = '<span class="read-more-btn">Read more</span>';
    while (words.length) {
      $firstP.html(words.join(' ') + btn);
      if ($firstP[0].scrollHeight <= maxH) break;
      words.pop();
    }
  }

  function initAll() {
    $('.team_description, .category_intro_content').each(function () {
      var $desc = $(this);

      if (!$desc.data('read-more-init')) {
        $desc.data('read-more-init', true).attr('data-state', 'collapsed');

        $desc.find('p').each(function () {
          if (!$(this).text().replace(/\u00A0/g, '').trim()) $(this).remove();
        });

        var $paras = $desc.find('p');
        if (!$paras.length) {
          $desc.removeAttr('data-state');
          return;
        }

        var $firstP = $paras.first();
        if ($paras.length > 1) {
          var $moreContent = $('<div class="more-content"></div>');
          $paras.slice(1).each(function () { $moreContent.append(this); });
          $desc.append($moreContent);
        }
        $firstP.attr('data-original', $firstP.html());
      }

      if ($desc.attr('data-state') === 'collapsed') truncate($desc);
    });
  }

  initAll();

  function retruncateAll() {
    $('.team_description, .category_intro_content').each(function () {
      if ($(this).attr('data-state') === 'collapsed') truncate($(this));
    });
  }

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(retruncateAll);
  $(window).on('load', retruncateAll);

  $(document).on('click', '.read-more-btn', function () {
    var $desc = $(this).closest('.team_description, .category_intro_content');
    var $firstP = $desc.find('p').first();
    var $moreContent = $desc.find('.more-content');

    $desc.attr('data-state', 'expanded');
    $firstP.html($firstP.attr('data-original'));

    if ($moreContent.length) {
      $moreContent.slideDown(250, function () {
        var $lastP = $moreContent.find('p').last();
        if (!$lastP.find('.read-less-btn').length) {
          $lastP.append(' <span class="read-less-btn">Read less</span>');
        }
      });
    } else if (!$firstP.find('.read-less-btn').length) {
      $firstP.append(' <span class="read-less-btn">Read less</span>');
    }
  });

  $(document).on('click', '.read-less-btn', function () {
    var $desc = $(this).closest('.team_description, .category_intro_content');
    var $moreContent = $desc.find('.more-content');

    $desc.attr('data-state', 'collapsed');
    $(this).remove();

    if ($moreContent.length) {
      $moreContent.slideUp(250, function () {
        truncate($desc);
        var top = $desc.offset().top, scroll = $(window).scrollTop();
        if (top < scroll) $('html, body').animate({ scrollTop: top - 100 }, 200);
      });
    } else {
      truncate($desc);
    }
  });

  var resizeTimer;
  $(window).on('resize orientationchange', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(retruncateAll, 150);
  });
});